import { render, staticRenderFns } from "./Lucky5_Regular.vue?vue&type=template&id=58a9c936&"
import script from "./Lucky5_Regular.vue?vue&type=script&lang=js&"
export * from "./Lucky5_Regular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports